import { StaticBaseDao } from '@/dao';
import { CommunicationToApprove } from '@/objects/generated';
import { useUserStore } from '@/stores';

export class CommunicationToApproveDao extends StaticBaseDao {
    public static async Fetch(uids: number[], detailed: boolean): Promise<CommunicationToApprove[]> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return [];
        }
        return this.BaseFetchArray(
            CommunicationToApprove,
            `CommunicationToApprove/Fetch` +
                '?' +
                (uids == undefined ? '' : `${this.makeGetStringFromList(uids, 'uids')}`) +
                '&' +
                (detailed == undefined ? '' : `detailed=${detailed}`),
            'GET',
        );
    }
    public static async SetCommunicationApprovalStatus(ID: number, approved: boolean): Promise<void | null> {
        const { user } = useUserStore();
        if (user === null || !user.IsSuperAdmin) {
            return null;
        }
        return this.Get(
            `CommunicationToApprove/SetCommunicationApprovalStatus` +
                '?' +
                (ID == undefined ? '' : `ID=${ID}`) +
                '&' +
                (approved == undefined ? '' : `approved=${approved}`),
        );
    }
}
